import { Button, Input, Popconfirm } from "@renderbus/ui";
import { message } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const TextItemWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 10px;
`;
const TextItem = styled.span`
  line-height: 30px;
  display: inline-block;
  width: 360px;
`;
const InputItemWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 10px;
`;

enum ButtonTypeColor {
  confirm = "#13cb75",
  delete = "red",
  cancel = "gray",
}

const DeleteButton = styled(Button)`
  color: ${ButtonTypeColor.delete};
  &:hover {
    color: ${ButtonTypeColor.delete};
  }
`;
type MultipleInputProps = {
  // 翻译模块名称
  translationModuleName?: string;
  inputPlaceholder?: string;
  defaultData?: string[];
  onDataChange?: (data: string[]) => void;
  onAddItem?: (data: string) => boolean;
  onRemoveItem?: (data: string) => void;
  // 设置添加数据的最大条数
  maxLength?: number;
  // 设置校验 可以设置为false即不校验 默认为邮箱格式
  inputReg?: any;
  // 校验出错提示
  formatValidatorError?: string;
  // 已存在提示
  existedValidatorError?: string;
  // 删除二次确认框
  deleteConfirmTitle?: string;
  okText?: string;
  cancelText?: string;
  confirmText?: string;
  deleteText?: string;
  // 添加按钮文案
  addButtonText?: string;
  // 限制输入框值最小长度
  inputMinLength?: number;
  // 限制输入框值最大长度
  inputMaxLength?: number;
  hasDefaultValue?: boolean;
};

const MultipleInput: React.FC<MultipleInputProps> = ({
  translationModuleName = "notification",
  inputPlaceholder = "",
  defaultData = [],
  onDataChange,
  onAddItem,
  onRemoveItem,
  maxLength = 5,
  inputReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
  formatValidatorError = "notification_billing_email_format_tip",
  existedValidatorError = "notification_billing_email_exist_tip",
  deleteConfirmTitle = "notification_billing_email_delete_tip",
  okText = "notification_billing_email_confirm",
  cancelText = "notification_billing_email_cancel",
  confirmText = "notification_billing_email_confirm",
  deleteText = "notification_billing_email_delete",
  addButtonText = "notification_billing_email_add",
  inputMaxLength = 40,
  inputMinLength = 6,
  hasDefaultValue = false,
}) => {
  const { t } = useTranslation(translationModuleName);
  const [data, setData] = useState<string[]>([]);
  const [showInput, setShowInput] = useState(false);
  const [inputVal, setInputVal] = useState("");
  const onAdd = () => {
    setShowInput(true);
  };
  const onRemove = (value: string) => {
    setData(data.filter((item) => item !== value));
    onRemoveItem?.(value);
  };
  const onConfirm = (val: string) => {
    const value = val.trim();
    if ((inputReg && !inputReg.test(value)) || value.length < inputMinLength) {
      message.error(t(formatValidatorError));
      return;
    }
    const existed = data.some((item) => item === value);
    if (existed) {
      message.error(t(existedValidatorError));
      return;
    }
    const result = onAddItem?.(value);
    if (result) {
      setData(data.concat([value]));
      onDataChange?.(data.concat([value]));
      setShowInput(false);
      setInputVal("");
    }
  };
  const onInputChange = (event: any) => {
    setInputVal(event.target.value);
  };
  const onInputCancel = () => {
    setShowInput(false);
    setInputVal("");
  };
  useEffect(() => {
    setData(defaultData);
  }, [defaultData]);

  return (
    <>
      <div>
        {!hasDefaultValue && (
          <TextItemWrapper>
            <TextItem style={{ color: "yellow" }}>
              {t("notification_billing_email_add_no_default_placeholder")}
            </TextItem>
          </TextItemWrapper>
        )}
        {data.map((item, i) => (
          <TextItemWrapper key={item}>
            <TextItem>{item}</TextItem>
            {!(i === 0 && hasDefaultValue) && (
              <Popconfirm
                title={t(deleteConfirmTitle)}
                onConfirm={() => onRemove(item)}
                onCancel={() => {}}
                okText={t(okText)}
                cancelText={t(cancelText)}
                popType="other"
              >
                <DeleteButton type="text">{t(deleteText)}</DeleteButton>
              </Popconfirm>
            )}
          </TextItemWrapper>
        ))}
        {showInput && (
          <InputItemWrapper>
            <Input
              value={inputVal}
              onInput={onInputChange}
              maxLength={inputMaxLength}
              placeholder={inputPlaceholder}
            />
            <Button
              type="text"
              style={{ color: ButtonTypeColor.confirm }}
              onClick={() => onConfirm(inputVal)}
            >
              {t(confirmText)}
            </Button>
            <Button
              type="text"
              style={{ color: ButtonTypeColor.cancel }}
              onClick={onInputCancel}
            >
              {t(cancelText)}
            </Button>
          </InputItemWrapper>
        )}
      </div>
      {data.length < maxLength && (
        <Button type="primary" onClick={onAdd} disabled={showInput}>
          {t(addButtonText)}
        </Button>
      )}
    </>
  );
};
export default MultipleInput;
